module.exports = __webpack_public_path__ + "img/085fd7d.jpg";